import React from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ErrorOutline } from "@mui/icons-material";

import { useAudienceUtils } from "@/hooks";
import { Audience } from "@/types";

interface CloneAudienceDialogProps {
  audience: Audience;
  open: boolean;
  onClose: () => void;
  onClone: () => void;
}

const CloneAudienceDialog: React.FC<CloneAudienceDialogProps> = ({
  audience,
  open,
  onClose,
  onClone,
}) => {

  const { utils, action } = useAudienceUtils(audience.audience_id, audience);

  return (
    <Dialog open={open} disableEnforceFocus aria-labelledby="delete-dialog">
      <DialogTitle>
        <Typography>Clone Audience</Typography>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography>
          Please confirm you wish to clone <b>{audience.audience_name}</b> as a new audience.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="info" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant={"contained"}
          size={"small"}
          onClick={utils.handleClone}
          loading={action.status === 'loading'}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloneAudienceDialog;
